import { rest } from 'msw'

export default [
  /**
   * SaiForce 演算設定
   */
  rest.get('/swc-api/nodes/:nodeId/saiforce/calculation-settings', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json(
        [
          {
              "node_id": "103",
              "dataset_id": "gw-006",
              "calculation_type": "saiforce",
              "calculation_setting": {
                  "common": {
                      "output_dataset_id": "gw-006-ex",
                      "hunting_window": 240.0
                  },
                  "modules": [
                      {
                        "module_name": "モジュール 44",
                        "water_intake": {
                            "water_intake_field": "saiforce_tw_FQ001_s1_SV",
                            "in_process_field": "W000508_07",
                            "out_process_field": [
                                "W000508_13",
                                "W000508_15",
                                "W000508_17",
                                "W000508_19",
                                "W000508_21",
                                "W000508_23",
                                "W000508_25",
                                "W000508_27",
                                "W000508_29",
                                "W000508_31",
                                "W000510_01",
                                "W000510_03"
                            ],
                            "water_intake_min": 20.0,
                            "water_intake_max": 2000.0
                        },
                        "anion": {
                            "direction": "positive",
                            "sensors": [
                                {
                                    "sensor_field": "saiforce_ars_X001_s1",
                                    "analog_field": "saiforce_ars_ex_FQ001_s1",
                                    "process_field": "saiforce_ars_ex_X001_s1",
                                    "sensor_min": 25.0,
                                    "sensor_max": 26.0
                                }
                            ]
                        },
                        "cation": {
                            "direction": "positive",
                            "sensors": [
                                {
                                    "sensor_field": "saiforce_ars_X001_s1",
                                    "analog_field": "saiforce_ars_ex_FQ001_s1",
                                    "process_field": "saiforce_ars_ex_X001_s1",
                                    "sensor_min": 25.0,
                                    "sensor_max": 26.0
                                }
                            ]
                        }
                      },
                      {
                        "module_name": "モジュール 45",
                        "water_intake": {
                            "water_intake_field": "saiforce_tw_FQ001_s1_SV",
                            "in_process_field": "W000508_07",
                            "out_process_field": [
                                "W000508_13",
                                "W000508_15",
                                "W000508_17",
                                "W000508_19",
                                "W000508_21",
                                "W000508_23",
                                "W000508_25",
                                "W000508_27",
                                "W000508_29",
                                "W000508_31",
                                "W000510_01",
                                "W000510_03"
                            ],
                            "water_intake_min": 20.0,
                            "water_intake_max": 2000.0
                        },
                        "anion": {
                            "direction": "positive",
                            "sensors": [
                                {
                                    "sensor_field": "saiforce_ars_X001_s1",
                                    "analog_field": "saiforce_ars_ex_FQ001_s1",
                                    "process_field": "saiforce_ars_ex_X001_s1",
                                    "sensor_min": 25.0,
                                    "sensor_max": 26.0
                                }
                            ]
                        },
                        "cation": {
                            "direction": "positive",
                            "sensors": [
                                {
                                    "sensor_field": "saiforce_ars_X001_s1",
                                    "analog_field": "saiforce_ars_ex_FQ001_s1",
                                    "process_field": "saiforce_ars_ex_X001_s1",
                                    "sensor_min": 25.0,
                                    "sensor_max": 26.0
                                }
                            ]
                        }
                      }
                  ]
              }
          }
        ]
      ),
    )
  }),
  rest.delete('/swc-api/nodes/:nodeId/saiforce/calculation-settings/:id', (req, res, ctx) => {
    // If authenticated, return a mocked user details
    return res(
      ctx.status(200),
      ctx.json([]),
    )
  }),

]
